export class MailingAddress {
    public active: boolean;
    public addressLine1: string;
    public addressLine2: string;
    public addressLine3: string;
    public addressType: {
        code: string,
        description: string
    };
    public block: string;
    public city:string;
    public coordinates: string;
    public country: {
        code: string,
        description: string
    };
    public county: string;
    public description: string;
    public displayText: string;
    public policyAddress: string;
    public postalCode: string;
    public primaryAddress: string;
    public publicId: string;
    public state: {
        code: string,
        description: string
    };
    public streetNumber: string;
}
